import userStorage from '@/shared/services/userStorage';

const defaultFont = 'Arial';
const defaultFontSize = 14;
export const ckEditorDefaultFontStorageKey = 'ckEditorDefaultFont';
export const ckEditorDefaultFontSizeStorageKey = 'ckEditorDefaultFontSize';

export default function defaultConfig(useDefaultFont) {
  return {
    extraPlugins: 'docprops,base64image,sourcedialog,autogrow',
    entities: false,
    removePlugins:
      'about,flash,forms,iframe,smiley,bidi,language,save,newpage,print,exportpdf,image,sourcearea, elementspath,resize',
    customConfig: '',
    autoGrow_minHeight: 200,
    autoGrow_maxHeight: 600,
    font_defaultLabel: useDefaultFont
      ? defaultFont
      : userStorage.getItem(ckEditorDefaultFontStorageKey) || defaultFont,
    fontSize_defaultLabel: useDefaultFont
      ? defaultFontSize
      : userStorage.getItem(ckEditorDefaultFontSizeStorageKey) || defaultFontSize,
    font_names:
      'Aptos/Aptos, sans-serif;Arial/Arial, Helvetica, sans-serif;Calibri/Calibri, sans-serif;Comic Sans MS/Comic Sans MS, cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif',
  };
}

export const onCkEditorLoaded = () => {
  if (!window.CKEDITOR) return;

  window.CKEDITOR.plugins.addExternal('base64image', '/ckeditor/plugins/base64image/plugin.js');
  window.CKEDITOR.plugins.addExternal('autogrow', '/ckeditor/plugins/autogrow/plugin.js');

  $.fn.modal.Constructor.prototype.enforceFocus = function() {
    // bootstrap-ckeditor-modal-fix
    // hack to fix ckeditor/bootstrap compatiability bug when ckeditor appears in a bootstrap modal dialog
    //
    // Include this AFTER both bootstrap and ckeditor are loaded.
    //https://stackoverflow.com/a/18554395
    const modal_this = this;

    $(document)
      .off('focusin.modal')
      .on('focusin.modal', function(e) {
        if (
          modal_this.$element[0] !== e.target &&
          !modal_this.$element.has(e.target).length &&
          !$(e.target.parentNode).hasClass('cke_dialog_ui_input_select') &&
          !$(e.target.parentNode).hasClass('cke_dialog_ui_input_text') &&
          !$(e.target.parentNode).hasClass('cke_dialog_ui_input_textarea')
        ) {
          modal_this.$element.focus();
        }
      });
  };
};

export const initializeCss = useDefaultFont => {
  if (!window.CKEDITOR) return;
  const font = useDefaultFont
    ? defaultFont
    : userStorage.getItem(ckEditorDefaultFontStorageKey) || defaultFont;
  const fontSize = useDefaultFont
    ? defaultFontSize
    : userStorage.getItem(ckEditorDefaultFontSizeStorageKey) || defaultFontSize;
  // https://stackoverflow.com/questions/50887220/how-to-set-default-font-and-font-size-in-ckeditor-4

  window.CKEDITOR.addCss(
    `.cke_editable{cursor:text; font-size: ${fontSize}px; font-family: ${font}, sans-serif;}`,
  );
};

if (window.CKEDITOR) {
  onCkEditorLoaded();
}
